import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	DialogActions,
	Button,
	AppBar,
	IconButton,
	Toolbar,
	Divider,
	Grid,
	Box,
	Chip,
	TextField,
	Alert,
} from '@mui/material'
import Transition from 'components/Transition'
import CloseIcon from '@mui/icons-material/Close'
import SaveAsTwoToneIcon from '@mui/icons-material/SaveAsTwoTone'
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase'
import { isEmpty } from 'lodash'
import { type } from 'os'
import { replaceEnterToBr } from 'util/stringUtil'
import { AskType } from 'constants/appType'

const AskPopup = ({
	popupIsOpen,
	onPopupClose,
	askDetail,
	setAskDetail,
	popupSave,
}: {
	popupIsOpen: boolean
	onPopupClose: () => void
	askDetail: AskType
	setAskDetail: React.Dispatch<React.SetStateAction<AskType>>
	popupSave: () => void
}) => {
	return (
		<Dialog
			open={popupIsOpen}
			onClose={onPopupClose}
			maxWidth="lg"
			slots={{
				transition: Transition,
			}}
		>
			<AppBar sx={{ position: 'sticky' }}>
				<Toolbar>
					<Typography
						sx={{ flex: 1 }}
						variant="h6"
						component="div"
					>
						1:1 문의
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						onClick={onPopupClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<Grid
					container
					spacing={2}
					sx={{ mt: 1 }}
				>
					<Grid size={{ xs: 12, md: 6 }}>
						<Box sx={{ display: 'flex' }}>
							{!isEmpty(askDetail.answerMessage) ? (
								<Chip
									label="답변완료"
									color="success"
									size="small"
									sx={{ mr: 1 }}
								/>
							) : (
								<Chip
									label="미답변"
									color="warning"
									size="small"
									sx={{ mr: 1 }}
								/>
							)}
							<Chip
								label={askDetail.type}
								size="small"
								color="info"
								sx={{ mr: 1 }}
							/>
						</Box>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<Typography
							align="right"
							variant="body2"
							color="textSecondary"
						>
							{askDetail.createdAt}
						</Typography>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<Divider sx={{ mb: 1 }} />
						<Typography
							variant="h5"
							fontWeight="bold"
							gutterBottom
						>
							{askDetail.title}
						</Typography>
						<Typography
							sx={{ m: 0 }}
							variant="subtitle1"
							color="textSecondary"
						>
							{askDetail.name} {!isEmpty(askDetail.phone) && `(${askDetail.phone})`}
						</Typography>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<Divider sx={{ my: 1 }} />
						<Alert
							security="warning"
							sx={{ mb: 2 }}
						>
							<Typography
								variant="body1"
								dangerouslySetInnerHTML={{
									__html: replaceEnterToBr(askDetail.requestMessage),
								}}
							/>
						</Alert>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<Divider sx={{ my: 1 }} />
						<TextField
							multiline
							fullWidth
							minRows={4}
							label="답변"
							value={askDetail.answerMessage || ''}
							onChange={(e) =>
								setAskDetail({ ...askDetail, answerMessage: e.target.value })
							}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<Divider />
			<DialogActions>
				<Button
					variant="contained"
					color="primary"
					size="small"
					startIcon={<SaveAsTwoToneIcon />}
					onClick={popupSave}
				>
					저장
				</Button>
				<Button
					variant="contained"
					color="secondary"
					size="small"
					startIcon={<PhonelinkEraseIcon />}
					onClick={onPopupClose}
				>
					닫기
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AskPopup
